import StaticLanguagePage from '../StaticLanguagePage';
import germanPageData from './germanPageData';

export default function GermanStaticPage() {
  return <StaticLanguagePage language={germanPageData} />;
}
